export default "__VITE_ASSET__CAzP2oqH__"